import React from 'react'
import { FormikProps } from 'formik'
import { Typography } from 'antd'
import { useTranslation } from 'react-i18next'

import { PolicyOperator } from 'src/types'
import Select from '../Select'

interface OperatorProps {
  type: PolicyOperator
}

export function Operator({ type }: OperatorProps) {
  const { t } = useTranslation()
  let message
  switch (type) {
    case PolicyOperator.LESS_THAN:
      message = t('common.condition.less-than')
      break
    case PolicyOperator.LESS_THAN_OR_EQUAL_TO:
      message = t('common.condition.less-than-or-equal')
      break
    case PolicyOperator.EQUALS:
      message = t('common.condition.equal')
      break
    case PolicyOperator.GREATER_THAN_OR_EQUAL_TO:
      message = t('common.condition.greater-than-or-equal')
      break
    case PolicyOperator.GREATER_THAN:
      message = t('common.condition.greater-than')
      break
    default:
      message = t('common.undefined')
  }
  return <Typography.Text>{message}</Typography.Text>
}

interface Props {
  disabled?: boolean
  formikProps: FormikProps<any>
  label?: string
  name?: string
}

export default function SelectOperator({
  name = 'operator',
  label = 'common.condition.title',
  disabled = false,
  formikProps
}: Props) {
  const { t } = useTranslation()
  const operators = [
    {
      label: t('common.condition.less-than'),
      value: '<'
    },
    {
      label: t('common.condition.less-than-or-equal'),
      value: '<='
    },
    {
      label: t('common.condition.equal'),
      value: '=='
    },
    {
      label: t('common.condition.greater-than-or-equal'),
      value: '>'
    },
    {
      label: t('common.condition.greater-than'),
      value: '>='
    }
  ]
  return (
    <Select
      dataTestId="operator-list"
      disabled={disabled}
      formikProps={formikProps}
      label={label}
      name={name}
      options={operators}
    />
  )
}
